module.exports = __webpack_public_path__ + "media/FoundExpert.aad167cd.mp3";